import React, { useState } from "react";
import LoyaltyProgress from "./LoyaltyProgress";
import LoyaltyRef from "./LoyaltyRef";
import LoyaltySocial from "./LoyaltySocial";
import LoyaltyBalance from "./LoyaltyBalance";
import LoyaltyHistory from "./LoyaltyHistory";
import LoyaltyTop from "./LoyaltyTop/LoyaltyTop";

const LkLoyalty = (props) => {

    return (
        <>
            {/* Десктоп */}
            <div className="w-full h-full p-[22px] xl:flex gap-[20px] hidden overflow-y-auto hide-scrollbar">
                <div className="w-[60%]">
                    <LoyaltyTop />
                    <LoyaltyProgress data={props.data} profile={props.profile} loalty={props.loalty} loalty_progress={props.loalty.loalty_progress} />
                    <LoyaltyRef profile={props.profile} />
                    <LoyaltySocial subsData={props.subsData} subsUrls={props.subsUrls} />
                </div>
                <div className="w-[40%]">
                    <LoyaltyBalance profile={props.profile} />
                    <LoyaltyHistory profile={props.profile} />
                </div>
            </div>


            {/* Планшет */}
            <div className="w-full h-full  xl:hidden md:block hidden p-[22px] overflow-y-auto hide-scrollbar">
                <LoyaltyTop />
                <LoyaltyProgress data={props.data} profile={props.profile} loalty_progress={props.loalty.loalty_progress} />
                <div className="flex justify-between items-start gap-[20px]">
                    <div className="w-[50%] min-h-[65%]  flex-row gap-[20px] justify-between">
                        <div className="w-[100%] ">
                            <LoyaltyRef profile={props.profile} />
                        </div>
                        <div className="w-[100%] ">
                            <LoyaltySocial subsData={props.subsData} subsUrls={props.subsUrls} />
                        </div>
                    </div>
                    <div className="w-[50%]  gap-[20px] justify-between">
                        <div className="w-[100%]">
                            <LoyaltyBalance profile={props.profile} />
                        </div>
                        <div className="w-[100%]">
                            <LoyaltyHistory profile={props.profile} />
                        </div>

                    </div>
                </div>

            </div>


            {/* Мобилка */}
            <div className="w-full md:hidden mt-[20px]   sm:px-[30px] px-[20px] "
                style={{
                    backgroundColor: '#EFF0F2'
                }}>
                <LoyaltyTop />
                <LoyaltyProgress data={props.data} profile={props.profile} loalty_progress={props.loalty.loalty_progress} />
                <LoyaltyBalance profile={props.profile} />
                <LoyaltyRef profile={props.profile} />
                <LoyaltyHistory profile={props.profile} />
                <LoyaltySocial subsData={props.subsData} subsUrls={props.subsUrls} />
            </div>

        </>
    )
}

export default LkLoyalty;
